import api from "./baseApi";
import endpoints from "./endpoints";

// ----------------------------
// Get devices (index)
// ----------------------------
export const getDevices = async ({ page = 1, perPage = 10 } = {}) => {
  try {
    const res = await api.get(endpoints.device.base, {
      params: { page, perPage },
    });

    return res.data;
  } catch (err) {
    const message =
      err.response?.data?.message || "failed to fetch devices";

    throw new Error(message);
  }
};

// ----------------------------
// Get single device (show + sync)
// ----------------------------
export const getDevice = async (id) => {
  try {
    const res = await api.get(endpoints.device.detail(id));
    return res.data;
  } catch (err) {
    const message =
      err.response?.data?.message || "failed to fetch device";

    throw new Error(message);
  }
};

// ----------------------------
// Update device
// ----------------------------
export const updateDevice = async (id, payload) => {
  try {
    const res = await api.put(endpoints.device.detail(id), payload);
    return res.data;
  } catch (err) {
    const message =
      err.response?.data?.message || "failed to update device";

    throw new Error(message);
  }
};

// ----------------------------
// Switch devices (bulk control)
// ----------------------------
export const switchDevices = async ({ ids, state }) => {
  try {
    const res = await api.post(endpoints.device.switch, {
      ids,
      state,
    });

    return res.data;
  } catch (err) {
    const message =
      err.response?.data?.message || "failed to switch devices";

    throw new Error(message);
  }
};

// ----------------------------
// Get device selections (DB only, no Tuya sync)
// ----------------------------
export const getDeviceSelections = async ({ page = 1, perPage = 10 } = {}) => {
  try {
    const res = await api.get(endpoints.device.selections, {
      params: { page, perPage },
    });

    return res.data;
  } catch (err) {
    const message =
      err.response?.data?.message || "failed to fetch device selections";

    throw new Error(message);
  }
};

// ----------------------------
// Delete device schedule
// ----------------------------
export const deleteDeviceSchedule = async (id) => {
  try {
    const res = await api.delete(endpoints.deviceSchedule.detail(id));
    return res.data;
  } catch (err) {
    const message =
      err.response?.data?.message || "failed to delete device schedule";

    throw new Error(message);
  }
};